import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, share } from 'rxjs/operators';
import { ReusableStreamProperty } from '@ipreo/muni-shared';
import { GameDayRootReducerState } from '../../../state/root.state';
import { OrdersSegment } from '../../../gameday/data/gameDay-data.segmentations';
import { getData, getSegments } from './order-summary-chart.calculations';
import { GameDayModel } from '../../../models/gameday-model';

@Injectable()
export class OrderSummaryChartService {
  @ReusableStreamProperty
  public readonly data: Observable<GameDayModel.RawData> = this.store.pipe(
    select(({ gameDay: { data, profile: { activeAccount } } }) => ({
      data,
      activeAccount
    })),
    filter(({ data: { deal }, activeAccount }) => !!deal && !!activeAccount),
    distinctUntilChanged(
      (prev, next) =>
        prev.data === next.data && prev.activeAccount === next.activeAccount
    ),
    map(getData),
    share()
  );

  public readonly segments: Observable<OrdersSegment<any>[]> = this.data.pipe(
    map(getSegments)
  );

  constructor(private store: Store<GameDayRootReducerState>) {}
}
